import { useGoogleTag } from "../../../hooks/useGoogleTag";
import { useFormStoreDatasContext } from "../../../store/useFormStoreDatas";
import { useEffect, useState } from "react";

export const StepProvider = ({ handleSecondStep }: { handleSecondStep: (type: string) => void }) => {
    useGoogleTag('StepProvider');
    const { formDatas } = useFormStoreDatasContext();
    const [position, setPosition] = useState<number | null>(null)
    const tabs = [
        {
            title: "SFR"
        },
        {
            title: "Bouygues"
        },
        {
            title: "Orange / Sosh"
        },
        {
            title: "Free"
        },
        {
            title: "Autre"
        },
        {
            title: "Aucune"
        },
    ];

    useEffect(() => {
        if (formDatas.provider) {
            setPosition(tabs.findIndex(tab => tab.title === formDatas.provider));
        }
    }, [formDatas]);
    return (
        <>
            <div className="w-full">
                <div className="flex flex-col gap-8 md:pb-10">
                    <h3 className="text-center font-bold text-xl lg:text-lg px-2">Quelle est votre box Internet actuelle ?</h3>
                    <div className="grid grid-cols-1 gap-2.5 md:grid-cols-2 lg:grid-cols-1 sm:gap-3 md:gap-4 lg:gap-1.5">
                        {tabs.map((tab, index) => (
                            <button key={index} onClick={() => handleSecondStep(tab.title)} className={`group relative w-[80%] md:w-1/2 lg:w-[250px] mx-auto p-4 sm:p-5 md:p-4 lg:p-2 rounded-full border-2 text-left transition-all duration-300 ease-spring hover:scale-[1.01] sm:hover:scale-[1.02] active:scale-[0.98] bg-card border-border hover:shadow-card flex items-center justify-between ${position === index ? "border-primaryNewComparateurFibre text-primaryNewComparateurFibre bg-white" : "bg-primaryNewComparateurFibre text-white hover:border-primaryNewComparateurFibre hover:text-primaryNewComparateurFibre hover:bg-white"}`}>
                                <span className="text-[19px] text-center sm:text-base md:text-lg lg:text-[18px] mx-auto">{tab.title}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};
